import React from "react";
import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];
const VIEWPORT = { once: true, margin: "-80px" };

export function Reveal({ children, delay = 0, y = 40, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={VIEWPORT}
      transition={{ duration: 0.8, ease, delay }}
    >
      {children}
    </motion.div>
  );
}

export function Overline({ children, className = "" }) {
  return (
    <span className={`text-xs md:text-sm uppercase tracking-[0.3em] text-epic-gold font-semibold ${className}`}>
      {children}
    </span>
  );
}
